module.exports = __webpack_public_path__ + "static/media/mymfbcover_pt_BR.b86eabf3.png";